/**
 * Constants and default data for BulkSampleEntry
 */

import { Microscope, Waves, Target, Circle, Zap } from 'lucide-react';

// Default locations
export const DEFAULT_LOCATIONS = [
  'A - Toftøy',
  'B - Føresvik', 
  'C - Rosshl.',
  'D - Høgsfj.',
  'E - Finnøyfj.',
  'F - Årdalsfj.',
  'G - Jøsenfj.',
  'H - Erfj.',
  'I - Jelsa',
  'J - Vindafj.',
  'K - Rott',
  'L - Boknafj.'
];

// Default zooplankton organisms
export const DEFAULT_ZOOPLANKTON_ORGANISMS = [
  { sampleType: 'Håvtrekk', organism: 'Mikromaneter', isSpecies: true },
  { sampleType: 'Håvtrekk', organism: 'Kolonimaneter', isSpecies: true },
  { sampleType: 'Håvtrekk', organism: 'Små maneter', isSpecies: true },
  { sampleType: 'Håvtrekk', organism: 'Radiolaria', isSpecies: true },
  { sampleType: 'Håvtrekk', organism: 'Pigghudlarver', isSpecies: true },
  { sampleType: 'Håvtrekk', organism: 'Foraminifera', isSpecies: true },
  { sampleType: 'Håvtrekk', organism: 'Hydroider', isSpecies: true },
  { sampleType: 'Håvtrekk', organism: 'Larver skjell', isSpecies: true },
  { sampleType: 'Håvtrekk', organism: 'Ribbemanet', isSpecies: true },
  { sampleType: 'Visuelt', organism: 'Manet', isSpecies: true }
];

// Default algae organisms
export const DEFAULT_ORGANISMS = [
  // Kiselalger
  { group: 'Kiselalger', species: 'Skeletonema', depth: 3, isSpecies: true },
  { group: 'Kiselalger', species: 'Chaetoceros', depth: 3, isSpecies: true },
  { group: 'Kiselalger', species: 'Pseudo-Nitzschia', depth: 3, isSpecies: true },
  { group: 'Kiselalger', species: 'Div', depth: 3, isSpecies: true },
  { group: 'Kiselalger', species: 'KISELALGER SUM', depth: '', isSum: true },
  
  // Svepeflagellater
  { group: 'Svepeflagellater', species: 'Chryso/Prymn', depth: 5, isSpecies: true },
  { group: 'Svepeflagellater', species: 'Phaeocystis', depth: 5, isSpecies: true },
  
  // Nåleflagellater
  { group: 'Nåleflagellater', species: 'Pseudochatonella', depth: 3, isSpecies: true },
  
  // Kiselflagellater
  { group: 'Kiselflagellater', species: 'Dictyocha/Vicicitus', depth: 5, isSpecies: true },
  
  // Fureflagellater
  { group: 'Fureflagellater', species: 'Alexandrium', depth: 5, isSpecies: true }
];

// Organism groups
export const ORGANISM_GROUPS = [
  'Kiselalger',
  'Svepeflagellater', 
  'Nåleflagellater',
  'Kiselflagellater',
  'Fureflagellater'
];

// Group icons mapping
export const GROUP_ICONS = {
  'Kiselalger': Microscope,
  'Svepeflagellater': Waves, 
  'Nåleflagellater': Target,
  'Kiselflagellater': Circle,
  'Fureflagellater': Zap
};

// Group colors (Tailwind classes)
export const GROUP_COLORS = {
  'Kiselalger': 'text-blue-600 bg-blue-50 border-blue-200',
  'Svepeflagellater': 'text-teal-600 bg-teal-50 border-teal-200',
  'Nåleflagellater': 'text-purple-600 bg-purple-50 border-purple-200', 
  'Kiselflagellater': 'text-emerald-600 bg-emerald-50 border-emerald-200',
  'Fureflagellater': 'text-orange-600 bg-orange-50 border-orange-200'
};

// Species by group
export const SPECIES_BY_GROUP = {
  'Kiselalger': ['Skeletonema', 'Chaetoceros', 'Pseudo-Nitzschia', 'Div'],
  'Svepeflagellater': ['Chryso/Prymn', 'Phaeocystis'],
  'Nåleflagellater': ['Pseudochatonella'],
  'Kiselflagellater': ['Dictyocha/Vicicitus'],
  'Fureflagellater': ['Alexandrium']
};

// Sample types for zooplankton
export const DEFAULT_SAMPLE_TYPES = ['Håvtrekk', 'Visuelt'];

// Organisms by sample type
export const DEFAULT_ORGANISMS_BY_SAMPLE_TYPE = {
  'Håvtrekk': ['Mikromåneter', 'Kolonnmaneter', 'Pigghudlarver', 'Foraminifera', 'Hydroider', 'Radiolaria', 'Larver skjell'],
  'Visuelt': ['Manet', 'Ribbemanet']
};
